import "./styles/footer.scss";

export default function Footer() {
  return (
    <footer>
      <p>PMW Inventory System V1.0.0</p>
      <p>&copy; Paul McFadden Wealth Ltd.</p>
    </footer>
  );
}
